import { useEffect, useState } from "react";
// import { BsLayoutSidebar } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import { SIDEBAR_ITEMS } from "./AddSidebarItems";

function SideBarList() {
  const [currentPageLink, setCurrentPageLink] = useState("/chat");

  const location = useLocation();

  useEffect(() => {
    setCurrentPageLink(location.pathname);
  }, [location.pathname]);

  const renderSidebarList = (item: any, index: number) => {
    if (item.link) {
      return (
        <Link
          key={index}
          to={item.link}
          className={`${
            currentPageLink.replace("/", "").replace("/", "") ===
            item.link.replace("/", "").replace("/", "")
              ? " transition-all duration-300 bg-cagActiveViolet"
              : " "
          } py-3 mx-2 flex`}
        >
          <li key={item.key} className=" px-4 flex items-center text-[14px]">
            {item.icon}
            {item.title}
          </li>
        </Link>
      );
    } else if (item.customJSX) {
      return <div key={item.key}>{item.customJSX}</div>;
    } else {
      return null;
    }
  };

  return (
    <div>
      <div className="scrollSidebar">
        <ul className="text-sidebarText space-y-2 bg-sidebarBlack">
          {SIDEBAR_ITEMS.map((item: any, index: number) =>
            renderSidebarList(item, index)
          )}
        </ul>
      </div>
    </div>
  );
}

export default SideBarList;
